/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input } from '@angular/core';
import { InfoRecordData } from '../../../../../../../../models/record/items/info-record.model';

@Component({
  selector: 'info-record',
  templateUrl: './info-record.component.html',
  styleUrls: ['./info-record.component.scss'],
  standalone: false
})
export class InfoRecordComponent {
  @Input() record!: InfoRecordData;

  constructor() {}
}
